import { combineReducers, createStore, Store } from 'redux';

import { IState } from './IState';
import UserReducer from './user/UserReducer';

const storeStateKey = 'StoreState';

const loadState = (): IState | undefined => {
  try {
    const serializedState = localStorage.getItem(storeStateKey);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch {
    return undefined;
  }
};

const saveState = (state: IState) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(storeStateKey, serializedState);
  } catch {
    // Ignore save errors
  }
};

const persistedState = loadState();

const configureStore = (): Store<IState, any> => {
  const marketShareStore: Store<IState, any> = createStore(
    combineReducers({
      UserReducer,
    }),
    persistedState,
  );

  marketShareStore.subscribe(() => {
    saveState(marketShareStore.getState());
  });

  return marketShareStore;
};

export default configureStore;
